import { useTranslation } from 'react-i18next'
import { Clock } from 'lucide-react'
import type { SettingsTab } from '../state/useSettingsTab'

interface TabPlaceholderProps {
  tab: SettingsTab
}

export function TabPlaceholder({ tab }: TabPlaceholderProps) {
  const { t } = useTranslation('settings')

  return (
    <div className="flex flex-col items-center justify-center gap-3 rounded-lg border border-border bg-card px-6 py-16 text-center">
      <Clock size={32} className="text-muted-foreground/50" />
      <p className="text-base font-semibold text-foreground">
        {t(`tab.${tab}`)} — {t('placeholder.comingSoon.title')}
      </p>
      <p className="max-w-xs text-sm text-muted-foreground">
        {t('placeholder.comingSoon.body')}
      </p>
    </div>
  )
}
